// Generated from localization/source.en.json by scripts/generate-frontend-fallback.ps1.
// Do not edit this file directly.
export const ENGLISH_FALLBACK = {
  ranking: 1,
  code: 'en',
  locale: 'en-GB',
  name: 'English',
  nativeName: 'English',
  direction: 'ltr',
  ui: {
    'common.skip': 'Skip to main content',
    'common.language': 'Language',
    'common.brandHome': 'IQLabTest home',
    'common.brandTagline': 'Cognitive assessment',
    'common.primaryNavigation': 'Primary navigation',
    'common.footerNavigation': 'Footer navigation',
    'common.home': 'Home',
    'common.iqGuides': 'IQ guides',
    'common.about': 'About',
    'common.startTest': 'Start test',
    'common.footerNote': 'Informative results. Responsible interpretation.',
    'common.email': 'Email',
    'common.continue': 'Continue',
    'common.status': 'Status',
    'common.active': 'Active',
    'common.item': 'Item',
    'common.version': 'Version',
    'common.published': 'Published',
    'common.valid': 'Valid',
    'common.locked': 'Locked',
    'common.pdf': 'PDF',
    'common.attempts': 'attempts',
    'common.credits': 'credits',
    'common.items': 'items',
    'common.developmentLogin': 'Development login',
    'common.error': 'This operation could not be completed.',
    'about.status': 'Indicative assessment platform',
    'about.eyebrow': 'Measured with care. Explained with context.',
    'about.title': 'A clearer view of cognitive strengths',
    'about.lede':
      'Complete an adaptive assessment across abstract, numerical, verbal, and spatial reasoning. Results are estimates with a confidence range - not a diagnosis or a final verdict about a person.',
    'about.how': 'See how it works',
    'about.startTest': 'Start the free 40-question test',
    'about.testNote': 'A new balanced question set is drawn for every attempt.',
    'about.company': 'Company workspace',
    'about.candidate': 'Candidate invitation',
    'about.transparent': 'Transparent by design',
    'about.expect': 'What you can expect',
    'about.adaptive': 'Adaptive',
    'about.adaptiveText': 'Questions respond to the evidence gathered so far.',
    'about.balanced': 'Balanced',
    'about.balancedText': 'Multiple reasoning domains contribute to the result.',
    'about.honest': 'Honest',
    'about.honestText': 'Reports show uncertainty, limitations, and assessment version.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'One source of information - not a hiring decision',
    'about.decisionText':
      'Employers must combine results with structured interviews, relevant experience, and human review. The platform does not label candidates as hire or reject.',
    'about.footer': 'Demo content and parameters are not psychometrically or clinically validated.',
    'about.nav': 'Primary navigation',
    'about.options': 'Assessment options',
    'admin.header': 'Platform administration',
    'admin.eyebrow': 'Restricted operations',
    'admin.title': 'Administration and compliance',
    'admin.lede':
      'Question review, calibration, billing visibility, jobs, audits, support, and privacy operations require the PlatformAdministrator role. Every mutation is audited.',
    'admin.login': 'Development administrator login',
    'admin.open': 'Open administration',
    'admin.overview': 'Operational overview',
    'admin.users': 'Users',
    'admin.publishedItems': 'Published items',
    'admin.payments': 'Payments',
    'admin.invoices': 'Invoices',
    'admin.privacyQueue': 'Privacy queue',
    'admin.failedJobs': 'Failed jobs',
    'admin.review': 'Question review and calibration',
    'admin.reviewText':
      'Exports include answer keys and are restricted to administrators. Published versions remain immutable.',
    'admin.import': 'Import original draft',
    'admin.publish': 'Publish',
    'admin.privacy': 'Privacy and disputes',
    'admin.process': 'Process',
    'admin.jobs': 'Jobs and retention',
    'admin.jobsText':
      'Cleanup expires stale invitations and releases their reserved credits through the ledger.',
    'admin.cleanup': 'Run cleanup',
    'admin.audit': 'Recent audit trail',
    'admin.error': 'Administrator access is required, or the operation could not be completed.',
    'candidate.header': 'Candidate assessment',
    'candidate.eyebrow': 'Indicative assessment',
    'candidate.title': 'Your assessment',
    'candidate.lede':
      'This assessment estimates reasoning performance with uncertainty. It is not a diagnosis or a hiring recommendation, and an employer must not use it as the sole selection criterion.',
    'candidate.redeemTitle': 'Redeem invitation',
    'candidate.token': 'Secure invitation token',
    'candidate.redeem': 'Redeem',
    'candidate.organization': 'Organization',
    'candidate.consent':
      'I understand that completion status, an indicative estimate, confidence interval, duration, and limitations are shared with the employer. Individual answers are not shared. Data is retained for 365 days under consent version candidate-consent-v1 and privacy-v1.',
    'candidate.accept': 'Accept and start',
    'candidate.complete': 'Assessment complete',
    'candidate.answered': 'Answered items',
    'candidate.saved': 'Your progress is saved after every accepted answer.',
    'candidate.error':
      'This step could not be completed. The invitation may be invalid, expired, or already used.',
    'company.header': 'Company workspace',
    'company.eyebrow': 'Development access',
    'company.title': 'Organization setup',
    'company.lede':
      'Create and view organizations through the tenant-protected API. Development login is disabled outside the Development environment.',
    'company.validEmail': 'Enter a valid email address.',
    'company.signedIn': 'Signed in for development as',
    'company.organizations': 'Organizations',
    'company.newOrganization': 'New organization name',
    'company.create': 'Create',
    'company.organizationRequired': 'Enter an organization name.',
    'company.none': 'No organizations are available for this account.',
    'company.manage': 'Manage',
    'company.dashboard': 'Campaign dashboard',
    'company.availableCredits': 'Available credits',
    'company.reservedCredits': 'Reserved credits',
    'company.consumedCredits': 'Consumed credits',
    'company.invitations': 'Invitations',
    'company.completed': 'Completed',
    'company.completionRate': 'Completion rate',
    'company.billing': 'Credit bundles and invoices',
    'company.simulated': 'Development purchases are simulated and never charge money.',
    'company.purchase': 'Simulate purchase',
    'company.refund': 'Refund unused credits',
    'company.campaignsFor': 'Campaigns for',
    'company.assessmentCredits': 'assessment credits available.',
    'company.addCredits': 'Add 10 development credits',
    'company.newCampaign': 'New campaign name',
    'company.createActivate': 'Create and activate',
    'company.noCampaigns': 'No campaigns yet.',
    'company.issue': 'Issue invitation',
    'company.invitationCreated': 'Invitation created - shown once',
    'company.openCandidate': 'Open candidate flow',
    'company.error':
      'The request could not be completed. Check that the API and database are running.',
    'consumer.header': 'Personal assessment',
    'consumer.eyebrow': 'Original demonstration assessment',
    'consumer.title': 'Understand your reasoning profile',
    'consumer.lede':
      'Receive an indicative estimate with an uncertainty interval. This is not a diagnosis or an official intelligence test, and the demonstration items are not psychometrically validated.',
    'consumer.noPayment': 'Development environment - no real payment will be taken.',
    'consumer.choose': 'Choose an assessment',
    'consumer.start': 'Start or resume',
    'consumer.saved': 'Progress is saved after every accepted answer.',
    'consumer.preview': 'Your limited preview',
    'consumer.previewTextBefore': 'Based on',
    'consumer.previewTextAfter':
      'adaptive items. The full result remains locked until server-confirmed payment.',
    'consumer.unlock': 'Unlock',
    'consumer.paymentSimulator': 'Development payment simulator',
    'consumer.paymentText':
      'No money is charged. Production uses the configured hosted payment provider.',
    'consumer.simulatePayment': 'Simulate verified payment',
    'consumer.paymentVerified': 'Payment verified. Your report is unlocked.',
    'consumer.history': 'Report history',
    'consumer.formats': 'Report formats',
    'consumer.accessibleHtml': 'Accessible HTML',
    'consumer.privacy': 'Privacy and result disputes',
    'consumer.privacyText':
      'Request a portable data export, account anonymization, or human review of a disputed result. Active legal holds are shown when an administrator processes a deletion request.',
    'consumer.export': 'Request export',
    'consumer.deletion': 'Request deletion',
    'consumer.dispute': 'Dispute result',
    'consumer.disputeReason': 'Please review my result.',
    'consumer.error': 'This step could not be completed. Your saved progress is unchanged.',
    'iq.assessment': 'Cognitive assessment',
    'iq.welcomeEyebrow': 'Your assessment, your language',
    'iq.languageTitle': 'Choose your online IQ test language',
    'iq.languageText':
      'Choose the language in which you want to complete the full assessment. Your randomized test starts only after you continue.',
    'iq.questionsLabel': 'questions',
    'iq.minutesLabel': 'minutes',
    'iq.domainsLabel': 'reasoning domains',
    'iq.startAssessment': 'Start assessment',
    'iq.answered': 'answered',
    'iq.timeRemaining': 'Time remaining',
    'iq.loading': 'Preparing your unique assessment',
    'iq.loadingText': 'Selecting a balanced set of 40 questions securely on the server.',
    'iq.engine': 'IQLabTest assessment engine',
    'iq.question': 'Question',
    'iq.of': 'of',
    'iq.reasoning': 'reasoning',
    'iq.previous': 'Previous',
    'iq.next': 'Next question',
    'iq.finish': 'Finish assessment',
    'iq.saved': 'Answer saved securely',
    'iq.resultEyebrow': 'Assessment complete',
    'iq.resultTitle': 'Your cognitive profile',
    'iq.estimate': 'Indicative IQ-style estimate',
    'iq.range': 'Indicative range',
    'iq.correct': 'questions correct',
    'iq.incorrect': 'questions incorrect',
    'iq.answerReviewEyebrow': 'Detailed feedback',
    'iq.answerReviewTitle': 'Review your answers',
    'iq.answerReviewText':
      'Compare your answer with the correct answer for every question in this completed assessment.',
    'iq.correctStatus': 'Correct',
    'iq.incorrectStatus': 'Incorrect',
    'iq.yourAnswer': 'Your answer',
    'iq.correctAnswer': 'Correct answer',
    'iq.notAnswered': 'Not answered',
    'iq.notAvailable': 'Not available',
    'iq.dashboardEyebrow': 'Personalized result',
    'iq.resultDashboardTitle': 'Understand your cognitive profile',
    'iq.percentileLabel': 'Estimated percentile',
    'iq.percentileContext': 'Approximate standing compared with a conventional IQ distribution.',
    'iq.precisionLabel': 'Indicative score range',
    'iq.precisionContext': 'A range is more responsible than treating one number as exact.',
    'iq.strongestLabel': 'Strongest area',
    'iq.focusLabel': 'Practice focus',
    'iq.domainProfileTitle': 'Reasoning domain profile',
    'iq.strength': 'Current strength',
    'iq.balanced': 'Balanced performance',
    'iq.practiceFocus': 'Practice opportunity',
    'iq.practicePlanTitle': 'Your recommended practice plan',
    'iq.practicePlanText':
      'Use the focused guides below to understand each reasoning style and practise deliberately before your next assessment.',
    'iq.reviewGuide': 'practice guide',
    'iq.timeSpent': 'seconds',
    'iq.explanationTitle': 'Responsible interpretation',
    'iq.explanation':
      'This practice estimate is based on this item bank and is not a standardized clinical IQ score. Do not use it for diagnosis, education, hiring, or other consequential decisions.',
    'iq.restart': 'Start a new randomized assessment',
    'iq.error': 'We could not start the assessment.',
    'iq.retry': 'Try again',
    'iq.identityEyebrow': 'Certificate details',
    'iq.identityTitle': 'Who should this result be issued to?',
    'iq.identityText':
      'Enter the candidate\u0027s first name, last name, and date of birth. The full name will appear on the certificate.',
    'iq.nameLabel': 'Candidate full name',
    'iq.namePlaceholder': 'e.g. Alexandra Morgan',
    'iq.firstNameLabel': 'First name',
    'iq.firstNamePlaceholder': 'e.g. Alexandra',
    'iq.lastNameLabel': 'Last name',
    'iq.lastNamePlaceholder': 'e.g. Morgan',
    'iq.dateOfBirthLabel': 'Date of birth',
    'iq.identityRequired': 'Enter a valid first name, last name, and date of birth.',
    'iq.nameNotice':
      'The name, date of birth, result, and completion date will be visible to anyone with the verification link or QR code.',
    'iq.issueCertificate': 'Save result and issue certificate',
    'iq.nameRequired': 'Enter a name between 2 and 120 characters.',
    'iq.downloadCertificate': 'Download PDF certificate',
    'iq.verifyResult': 'Open verification page',
    'iq.navigation': 'Question navigation',
    'verify.loading': 'Verifying result',
    'verify.firstName': 'First name',
    'verify.lastName': 'Last name',
    'verify.dateOfBirth': 'Date of birth',
    'verify.notAvailable': 'Not available',
    'verify.unavailable': 'Verification unavailable',
    'verify.failed': 'This result could not be verified',
    'verify.help': 'Check that the complete verification URL or QR code was used.',
    'verify.start': 'Start an IQLabTest assessment',
    'verify.verified': 'Verified result',
    'verify.details': 'Details match the original IQLabTest record',
    'verify.completed': 'Completed on',
    'verify.estimate': 'Indicative estimate',
    'verify.id': 'Verification ID',
    'verify.disclaimer':
      'This is an indicative practice result, not a clinical or standardized IQ score.',
    'verify.download': 'Download certificate',
    'verify.new': 'Start an assessment',
  },
  domains: { Abstract: 'Abstract', Numerical: 'Numerical', Verbal: 'Verbal', Spatial: 'Spatial' },
  bands: {
    'very-strong': 'Very strong practice performance',
    strong: 'Strong practice performance',
    typical: 'Typical practice range',
    developing: 'Developing practice range',
    'practice-more': 'More practice recommended',
  },
} as const;
